/* KeldCo cart drawer layout (2026-09-30)
   ----------------------------------------------------------------------
   The drawer's fixed footer had grown to four stacked blocks - shipping
   protection, savings, total, discount - tall enough to clip the upsells
   above it. On a real iPhone it was still eating about a fifth of the
   screen. Three things move out of the fixed bar:

     1. Shipping protection sits with the cart line items.
     2. The discount code collapses behind a one-line summary...
     3. ...and that summary also moves up into the scrolling area, so the
        fixed bar is only ever Total + Checkout.

   Done as a separate file rather than inside kc-cart.js so the existing
   bundle is untouched: this only re-parents nodes kc-cart.js has already
   built. Load it AFTER kc-cart.js.

   kc-cart.js repaints the drawer whenever the cart changes, which rebuilds
   its own markup in the original places, so this re-applies on mutation.
   It is idempotent and never removes anything kc-cart.js owns.            */
(function () {
  'use strict';

  function drawer() { return document.querySelector('#cart-drawer'); }

  function relocate() {
    var d = drawer();
    if (!d) return;
    var items = d.querySelector('.cart-drawer__line-items');
    var footer = d.querySelector('[slot="footer"]');
    if (!items || !footer) return;

    /* kc-cart.js clears .kc-dc on repaint but knows nothing about our
       wrapper, so sweep any that were left empty before making a new one. */
    var stale = d.querySelectorAll('.kc-dcw');
    for (var i = 0; i < stale.length; i++) {
      if (!stale[i].querySelector('.kc-dc')) stale[i].remove();
    }

    /* 1. shipping protection belongs with the items */
    var sp = footer.querySelector('.kc-sp');
    if (sp) items.insertAdjacentElement('afterend', sp);

    /* 2. collapse the discount code */
    var dc = d.querySelector('.kc-dc');
    if (dc && !dc.closest('.kc-dcw')) {
      var wrap = document.createElement('details');
      wrap.className = 'kc-dcw';
      var sum = document.createElement('summary');
      sum.className = 'kc-dcw__s';
      sum.textContent = 'Add a discount code';
      /* 2026-10-01: open it when kc-cart has a verdict to show, or the
         "can't be applied" line would be hidden inside a collapsed box. */
      wrap.open = !!dc.querySelector('.kc-dc__msg:not([hidden])');
      dc.parentNode.insertBefore(wrap, dc);
      wrap.appendChild(sum);
      wrap.appendChild(dc);
    }

    /* 3. and lift it out of the fixed bar, directly under shipping
          protection so it is still visible the moment the drawer opens */
    var w = d.querySelector('.kc-dcw');
    if (w && footer.contains(w)) {
      var anchor = d.querySelector('.kc-sp') || items;
      anchor.insertAdjacentElement('afterend', w);
    }
  }

  /* One pass per frame. kc-cart.js early-returns when the cart fingerprint
     is unchanged, so moving nodes does not start a repaint loop. */
  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; relocate(); });
  }

  function boot() {
    var d = drawer();
    if (!d) { setTimeout(boot, 400); return; }
    relocate();
    new MutationObserver(schedule).observe(d, { childList: true, subtree: true });
    document.addEventListener('click', function () { setTimeout(schedule, 120); }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();